"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createBasicConsoleLogger = createBasicConsoleLogger;
exports.createBrowserConsoleLogger = createBrowserConsoleLogger;
exports.createDataDogLogger = createDataDogLogger;
exports.createLoggerWithFlags = createLoggerWithFlags;
exports.createVoidLogger = createVoidLogger;
var _HpError = require("./HpError");
var _logger = require("./logger");
function createDataDogLogger(sensitiveDetailMask) {
  const {
    debug,
    info,
    notice,
    warn,
    error,
    critical
  } = createBasicConsoleLogger();
  const logger = {
    debug: message => debug((0, _logger.messageToJson)({
      message,
      level: 'DEBUG',
      sensitiveDetailMask
    })),
    info: message => info((0, _logger.messageToJson)({
      message,
      level: 'INFO',
      sensitiveDetailMask
    })),
    notice: message => notice((0, _logger.messageToJson)({
      message,
      level: 'NOTICE',
      sensitiveDetailMask
    })),
    warn: message => warn((0, _logger.messageToJson)({
      message,
      level: 'WARNING',
      sensitiveDetailMask
    })),
    error: message => error((0, _logger.messageToJson)({
      message,
      level: 'ERROR',
      sensitiveDetailMask
    })),
    critical: message => critical((0, _logger.messageToJson)({
      message,
      level: 'CRITICAL',
      sensitiveDetailMask
    }))
  };
  return logger;
}
function createVoidLogger() {
  return {
    debug: _logger.voidLogFunction,
    info: _logger.voidLogFunction,
    notice: _logger.voidLogFunction,
    warn: _logger.voidLogFunction,
    error: _logger.voidLogFunction,
    critical: _logger.voidLogFunction
  };
}
function createLoggerWithFlags(props) {
  const {
    flagType,
    allFlag
  } = props;
  const incorrectlyUsedAllFlagMessage = `Please use ${flagType}.None rather than ${flagType}.All.`;
  const createFlaggedFunc = logLevel => {
    return (message, flag) => {
      if (flag === allFlag) {
        throw new _HpError.HpError(incorrectlyUsedAllFlagMessage);
      }
      const isFlagged = flag === 0 || logLevel === 'error' || logLevel === 'critical' || (props.activeFlags & flag) === flag;
      if (isFlagged) {
        props.underlyingLogger[logLevel](message);
      }
      return isFlagged;
    };
  };
  const logger = {
    debug: createFlaggedFunc('debug'),
    info: createFlaggedFunc('info'),
    notice: createFlaggedFunc('notice'),
    warn: createFlaggedFunc('warn'),
    error: msg => props.underlyingLogger.error(msg),
    critical: msg => props.underlyingLogger.critical(msg)
  };
  return logger;
}
function createBasicConsoleLogger() {
  const {
    debug,
    info,
    warn,
    error
  } = console;
  return Object.freeze({
    debug: msg => {
      debug(msg);
      return true;
    },
    info: msg => {
      info(msg);
      return true;
    },
    notice: msg => {
      info(msg);
      return true;
    },
    warn: msg => {
      warn(msg);
      return true;
    },
    error: msg => {
      error(msg);
      return true;
    },
    critical: msg => {
      error(msg);
      return true;
    }
  });
}
function createBrowserConsoleLogger() {
  const wrapper = msg => {
    let res;
    let ts;
    const {
      timestamp,
      level
    } = msg || {};
    if (!!timestamp && !!level) {
      const tmp = msg;
      delete tmp.timestamp;
      delete tmp.level;
      ts = Date.parse(timestamp);
      res = JSON.stringify(msg, null, 2);
    } else {
      ts = new Date().getTime();
      res = JSON.stringify(msg, null, 2);
    }
    let tx = String(ts);
    tx = tx.substring(tx.length - 6);
    return `[@${tx}] ${res}`;
  };
  return (0, _logger.wrapLogger)(wrapper);
}